import React from 'react';
import './seat-map-zoom-actions.scss';
import classNames from 'classnames';
import {useControls} from 'react-zoom-pan-pinch';
import PlusIcon from '../../assets/icons0/plus.svg';
import MinusIcon from '../../assets/icons0/minus.svg';
import MarkIcon from '../../assets/icons0/mark.svg';
import CornerUpLeftIcon from '../../assets/icons0/corner-up-left.svg';

const MapActions = React.memo(({showInitialMap, initialScale}) => {
    const { zoomIn, zoomOut, centerView } = useControls();
    return (
        <div className='seat-map-zoom-actions position-absolute left-0 top-0 display-flex flex-direction-column row-gap-0dot5rem z-index-1'>
            <div className='display-flex flex-direction-column seat-map-zoom-actions__button-group'>
                <button className='seat-map-zoom-actions__button cursor-pointer border-1px-solid border-color-gray-300 background-color-white border-radius-0dot5rem padding-0dot25rem' onClick={() => zoomIn()}>
                    <PlusIcon className='display-block width-1dot25rem height-1dot25rem color-gray-500'/>
                </button>
                <button className='seat-map-zoom-actions__button cursor-pointer border-1px-solid border-color-gray-300 background-color-white border-radius-0dot5rem padding-0dot25rem' onClick={() => zoomOut()}>
                    <MinusIcon className='display-block width-1dot25rem height-1dot25rem color-gray-500'/>
                </button>
            </div>
            <button className='seat-map-zoom-actions__button cursor-pointer border-1px-solid border-color-gray-300 background-color-white border-radius-0dot5rem padding-0dot25rem' onClick={() => {centerView(initialScale)}}>
                <MarkIcon className='display-block width-1dot25rem height-1dot25rem color-gray-500'/>
            </button>
                <button className={classNames('seat-map-zoom-actions__button cursor-pointer border-1px-solid border-color-gray-300 background-color-white border-radius-0dot5rem padding-0dot25rem', {'seat-map-zoom-actions__button--hide': !showInitialMap})} onClick={() => showInitialMap()}>
                    <CornerUpLeftIcon className='display-block width-1dot25rem height-1dot25rem color-gray-500'/>
                </button>
        </div>
    )
});

export default React.memo(MapActions);